import Ripple from "components/Ripple";
import { env } from "env";
import { Link } from "react-router";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

export const Logo: React.FC = () => {
  const { network } = useSalesNetwork();
  const defaultBrand = network && network.brands && network.brands.length > 0 ? network.brands[0].brand : null;

  return (
    <Ripple>
      <Link
        data-height="fit"
        to=""
        data-type="group"
        data-align="center"
        data-direction="column"
        data-justify="center"
      //data-interactive=""
      >
        <group
          data-width="auto"
          data-wrap="no"
          data-gap="10"
          data-align="center"
          //data-space="10"
          data-space-horizontal="10"
        >
          {network &&
            network.brands.map((b) => (
              <group
                key={b.brand}
                data-direction="column"
                data-width="auto"
                data-max-length="180"
                //data-interactive=""
                data-align="center"
                data-justify="center"
                data-space="5"
              >
                <logo>
                  <img src={"/logos/" + b.brand + ".svg"} />
                </logo>
              </group>
            ))}
          {defaultBrand && defaultBrand === "ACV" &&
            <group
              data-direction="column"
              data-width="auto"
              data-max-length="180"
              data-align="center"
              data-justify="center"
              data-space="5"
            >
              <logo>
                <img src={"/logos/ACVProSelect.svg"} />
              </logo>
            </group>}
          {defaultBrand && defaultBrand === "ATLANTIC" &&
            <group
              data-direction="column"
              data-width="auto"
              data-max-length="180"
              data-align="center"
              data-justify="center"
              data-space="5"
            >
              <logo>
                <img src={`/logos/${(env.thermodim_logo || "ThermoDim.svg")}`} />
              </logo>
            </group>}
        </group>
      </Link>
    </Ripple>
  );
};
